module.exports = __webpack_public_path__ + "static/media/Thunderstorms.2aaf863c.md";